import { useEffect } from "react";

export default function useNoIndex() {
  useEffect(() => {
    const existingMeta = document.head.querySelector('meta[name="robots"]');
    const previousContent = existingMeta?.getAttribute("content") ?? null;
    const meta = existingMeta ?? document.createElement("meta");

    meta.setAttribute("name", "robots");
    meta.setAttribute("content", "noindex, nofollow, noarchive, max-snippet:0, max-image-preview:none");

    if (!existingMeta) {
      meta.setAttribute("data-creavideos-managed", "robots-noindex");
      document.head.appendChild(meta);
    }

    return () => {
      if (existingMeta) {
        if (previousContent === null) {
          meta.removeAttribute("content");
        } else {
          meta.setAttribute("content", previousContent);
        }
        return;
      }

      meta.remove();
    };
  }, []);
}
